export const SOQ_ACTION = "SOQ";
export const ESO_COMMON = "ESO_COMMON";
export const ESO_COMMON_SECONDARY = [
  "STATUS_INFO_PUSH_DATA",
  "PUT_SYSTEM_PAX_FIGURE",
  "SO_GENARAL_CUSTOMIZATION",
];
export const DASHBOARD_SEARCH_CRITERIA = "DASHBOARD_SEARCH_CRITERIA";
export const STORE_JOB_HISTORY = "STORE_JOB_HISTORY";
export const AC_SEAT_CFG_MODAL = "AC_SEAT_CFG_MODAL";
export const SEARCH_RULE = "SEARCH_RULE";
export const SEARCH_POLLING_POLICIES = "SEARCH_POLLING_POLICIES";

export const SERVICE_ORDER_QUERY_CRITERIA = "SERVICE_ORDER_QUERY_CRITERIA";
export const SEARCH_TOP_FOCUS_ITEMS = "SEARCH_TOP_FOCUS_ITEMS";
export const SMART_ORDER_DASHBOARD = "SMART_ORDER_DASHBOARD";
export const IMPORT_ORDER_QUERY_CRITERIA = "IMPORT_ORDER_QUERY_CRITERIA";
